/**
 * Leads arquivados — /crm/arquivados (R24). Wrapper fino sobre
 * LeadsListaTerminal (tipo="arquivados"). Ver esse componente para o design.
 */
import React from "react";

import LeadsListaTerminal from "./LeadsListaTerminal";

function LeadsArquivados() {
  return <LeadsListaTerminal tipo="arquivados" />;
}

export default LeadsArquivados;
